"use strict";
module.exports = {
    stockKeepingUnitTranslations: {
        id: 'id' || 'id',
        isMainUnit: 'Är huvudenhet' || 'isMainUnit',
        name: 'Enhet' || 'name',
        names: {
            lav: 'LAV' || 'lav',
            bag_in_box: 'BIB' || 'bag_in_box',
            PET: 'PET' || 'PET',
            pallet: 'pall' || 'pallet',
            package: 'kolli' || 'package',
            pcs: 'st' || 'pcs',
            kg: 'kg' || 'kg',
            hg: 'hg' || 'hg',
            g: 'g' || 'g',
            liter: 'liter' || 'liter',
            dl: 'dl' || 'dl',
            cl: 'cl' || 'cl',
            ml: 'ml' || 'ml',
            case: 'ask' || 'case',
            crate: 'back' || 'crate',
            bale: 'bal' || 'bale',
            big_box: 'bbox' || 'big_box',
            piece: 'bit' || 'piece',
            block: 'block' || 'block',
            book: 'bok' || 'book',
            tray: 'bricka' || 'tray',
            bouquet: 'bukett' || 'bouquet',
            bundle: 'bunt' || 'bundle',
            can: 'burk' || 'can',
            tub: 'bytta' || 'tub',
            mug: 'bägare' || 'mug',
            big_can: 'dunk' || 'big_can',
            disposable_glass: 'eng.glas' || 'disposable_glass',
            barrel: 'fat' || 'barrel',
            package4: 'flak' || 'package4',
            bottle: 'flaska' || 'bottle',
            braid: 'fläta' || 'braid',
            package2: 'förp' || 'package2',
            glass: 'glas' || 'glass',
            bucket: 'hink' || 'bucket',
            keg: 'kagge' || 'keg',
            capsules: 'kapslar' || 'capsules',
            sv_karta: 'karta' || 'sv_karta',
            carton: 'kartong' || 'carton',
            cassette: 'kassett' || 'cassette',
            bunch: 'klase' || 'bunch',
            bundle2: 'knippe' || 'bundle2',
            basket: 'korg' || 'basket',
            pot: 'kruka' || 'pot',
            quarter_pallet: 'kvartspall' || 'quarter_pallet',
            box: 'låda' || 'box',
            bulk: 'lösvikt' || 'bulk',
            m: 'm' || 'm',
            m2: 'm2' || 'm2',
            net: 'nät' || 'net',
            package3: 'paket' || 'package3',
            package5: 'platta' || 'package5',
            bag: 'påse' || 'bag',
            recycle_glass: 'ret.glas' || 'recycle_glass',
            roll: 'rulle' || 'roll',
            side: 'sida' || 'side',
            sack: 'säck' || 'sack',
            tetra: 'tetra' || 'tetra',
            trough: 'tråg' || 'trough',
            tube: 'tub' || 'tube',
            wagon: 'vagn' || 'wagon',
            unknown: 'Okänd' || 'unknown',
        },
        supplierName: 'Leverantörens enhet' || 'supplierName',
        GTIN: 'GTIN' || 'GTIN',
        quantityOfMainUnitPerUnit: 'Huvudenheter per enhet' || 'quantityOfMainUnitPerUnit',
        minOrderQuantity: 'Minsta kvantitet' || 'minOrderQuantity',
        stepOrderIncrement: 'Kvantitetssteg' || 'stepOrderIncrement',
        grossWeight: 'Bruttovikt' || 'grossWeight',
    },
};
